import './SignUpModal.scss';
import { Icon } from '../../icon/icon';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import ButtonLink from '../../common/ButtonLink/ButtonLink';
import { Form } from 'antd';
import InputComponent from '../../common/InputComponent/InputComponent';
import InputPasswordComponent from '../../common/InputPasswordComponent/InputPasswordComponent';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { register } from '../../../store/actions/auth.action';
import { useRef, useState } from 'react';
import { openModal } from '../../common/Modal/openModal';
import { openMessageError } from '../../common/Message/openMessageError';
import { Trans, useTranslation } from 'react-i18next';

const useSignUpModal = () => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState([]);
  const { t } = useTranslation();
  const modal = useRef(null);

  const { isLoading } = useSelector(state => state.auth);

  const submit = async values => {
    dispatch(
      register({
        ...values,
        redirect_url: window.location.origin,
      })
    )
      .then(res => {
        if (res.payload?.data) {
          // onClose();
          modal.current?.destroy();
          openModal({
            title: (
              <div className="flex self-stretch items-center justify-center">
                <img src="/assets/icons/success.svg" />
              </div>
            ),
            content: (
              <>
                <span className="text-headline-small text-center">
                  {t('Successfully')}
                </span>
                <span className="text-body-medium text-center">
                  <Trans
                    i18nKey={
                      'We have sent an email to {{email}} with a reset link to verify the email you used to register your account.'
                    }
                    values={{ email: values.email }}
                  />
                </span>
              </>
            ),
            centered: true,
            width: 538,
            classNames: {
              header: '!p-24 !m-0',
              body: '!p-24 flex flex-col items-center gap-16',
              footer: '!p-24 gap-16 items-end flex justify-end',
            },
            footer: <></>,
          });
        } else if (res.error || res.meta?.requestStatus === 'rejected') {
          openMessageError({
            content: res.error?.message || t('Something went wrong'),
          });
        }
      })
      .catch(error => {
        openMessageError({
          content: error?.message || t('Something went wrong'),
        });
      });
  };
  const openModalSignUp = ({ onOpenLogin }) => {
    modal.current = openModal({
      content: (
        <>
          <Form layout="vertical" onFinish={submit}>
            <div className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
              <h2 className="!font-bold">{t('Register')}</h2>
            </div>
            <div className="flex py-16 px-40 justify-center items-center gap-16 flex-col self-stretch">
              <Form.Item
                label={t('Name')}
                name={'fullname'}
                className="self-stretch"
                required
              >
                <InputComponent placeholder={t('Enter name')} size={'large'} />
              </Form.Item>
              <Form.Item
                label={'Email'}
                name={'email'}
                className="self-stretch"
                required
              >
                <InputComponent placeholder={t('Enter email')} size={'large'} />
              </Form.Item>
              <Form.Item
                label={t('Phone number')}
                name={'phone'}
                className="self-stretch"
              >
                <InputComponent
                  placeholder={t('Enter phone number')}
                  size={'large'}
                />
              </Form.Item>
              <Form.Item
                label={t('Password')}
                name={'password'}
                className="self-stretch"
                help={false}
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value) {
                        setErrors([]);
                        return Promise.resolve();
                      }
                      const errors = [];
                      if (value.length < 8) {
                        errors.push(
                          t('Password must be at least 8 characters.')
                        );
                      }
                      if (!/[A-Z]/.test(value)) {
                        errors.push(
                          t('Password must have at least 1 uppercase letter.')
                        );
                      }
                      if (!/[0-9]/.test(value)) {
                        errors.push(t('Password must have at least 1 digit.'));
                      }
                      if (!/[!@#$%^&*()]/.test(value)) {
                        errors.push(
                          t(
                            'Password must have at least 1 special character !@#$%^&*().'
                          )
                        );
                      }
                      if (errors.length > 0) {
                        setErrors(errors);
                        return Promise.reject(new Error());
                      }
                      setErrors([]);
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputPasswordComponent
                  placeholder={t('Enter password')}
                  visible={false}
                  size={'large'}
                />
              </Form.Item>
              {errors.length > 0 && (
                <ul
                  className="flex flex-col justify-start items-start gap-4 self-stretch m-0"
                  style={{ color: '#818589' }}
                >
                  {errors.map((error, index) => (
                    <li key={index}>
                      <span className="text-body-small">{error}</span>
                    </li>
                  ))}
                </ul>
              )}
              <Form.Item
                label={t('Confirm password')}
                name={'confirmPassword'}
                className="self-stretch"
                help={false}
                dependencies={['password']}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject();
                    },
                  }),
                ]}
              >
                <InputPasswordComponent
                  placeholder={t('Confirm password')}
                  visible={false}
                  size={'large'}
                />
              </Form.Item>
            </div>
            <Form.Item className="flex py-16 px-40 justify-center items-center gap-8 self-stretch">
              <ButtonPrimaryLarge
                title={t('Register')}
                className={'grow'}
                type={'submit'}
                disabled={isLoading}
                loading={isLoading}
              />
            </Form.Item>
            <div className="flex p-40 pt-16 justify-center items-center gap-8 self-stretch">
              <div className="flex justify-center items-center gap-8">
                <span className="text-body-medium">
                  {t('Already have a Fitta account?')}
                </span>
                <ButtonLink
                  title={t('Login')}
                  style={{ color: '#258FD2' }}
                  onClick={() => {
                    modal.current?.destroy();
                    onOpenLogin();
                  }}
                />
              </div>
            </div>
          </Form>
        </>
      ),
      title: (
        <div className="flex p-[40px] pb-[16px] justify-center items-center self-stretch m-0">
          <a
            href={'/'}
            style={{
              backgroundImage: 'url(/assets/logo/new_logo_fitta.png)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              height: '32px',
              width: '120px',
              display: 'inline-block',
            }}
          ></a>
          <ButtonIconGhostMedium
            icon={<Icon.ICClose />}
            style={{ border: '1px solid #CFD1D2' }}
            className={'absolute top-24 right-24'}
            onClick={() => {
              modal.current?.destroy();
            }}
          />
        </div>
      ),
      footer: null,
      centered: true,
      closable: false,
      classNames: { content: '!p-0 !rounded-[8px]', header: '!m-0' },
      width: 620,
    });
  };
  return { openModalSignUp };
};

export default useSignUpModal;
